import {customerService} from "@/services/CustomerService.class";
import {reportService} from "@/services/ReportService.class";
import {categoryService} from "@/services/CategoryService.class";
import {accountService} from "@/services/AccountService.class";
import Customer from '../model/Customer'
import WarningOption from '../model/WarningOption'

const state = {
  reports: [],
  customer: [],
  categories: [],
};
const actions = {
  /**
   *
   * @param context the context object of vuex
   * @param payload {Object}
   * @param payload.customerId {number} customer id
   * @param payload.search {string} string to search for
   * @param payload.localOnly {boolean} whether to search for local or ldap accounts
   * @param payload.page {Object}
   * @param payload.page.page {number} define pageindex starting at 0
   * @param payload.page.pageSortDirection {string} defines page sorting
   * @param payload.page.pageSize {number} defines page size
   */
  queryAccountsByCustomerId(context, payload) {
    return accountService.queryAccountsByCustomerId(
      payload.customerId,
      payload.search,
      payload.localOnly,
      payload.page)
  },
  getCustomersAction({commit}) {
    return new Promise(resolve => {
      customerService.get().then((response) => {
        const customers = [];
        response.data.forEach((customer) => {
          customers.push(new Customer(customer))
        });
        commit('setCustomers', customers);
        resolve(customers);
      });
    })
  },
  getCustomerByIdAction({state}, payload) {
    const filtered = state.customer.filter(customer => customer.id === payload);
    if (filtered.length > 0) {
      return filtered[0];
    } else {
      return customerService.getById(payload).then((response) => {
        return new Customer(response.data);
      })
    }
  },

  getCategoriesAction({commit}, tenantId = null) {
    categoryService.get(tenantId).then((response) => {
      let categories = [];
      response.data.forEach(category => {
        categories.push(new WarningOption(category.id, category.title, category.color, category.level, category.type))
      });
      commit('setCategories', categories);
    })
  },

  /**
   *
   * @param context
   * @param report {Report}
   * @returns {Promise<any>}
   */
  createReportAction(context, report) {
    return new Promise((resolve) => {
      reportService.create(
        report.subject,
        report.content,
        report.warningOption.value,
        report.customers.map(customer => customer.id),
        report.maintenanceStart,
        report.maintenanceEnd
      ).then(() => {
        resolve();
      })
    });
  },

  /**
   * @param context
   * @param reportId
   * @param update
   * @returns {Promise<ReportUpdate>}
   */
  createReportUpdateAction(context, {reportId, update}) {
    return new Promise((resolve) => {
        reportService.createUpdate(reportId, {text: update.content})
          .then((newReport) => resolve(newReport))
      }
    );
  },

  /**
   *
   * @param context
   * @param payload {report:Report, finalMessage: string}
   * @returns {Promise<any>}
   */
  patchReportAction(context, payload) {
    return new Promise((resolve) => {
      reportService.patch(payload.report, payload.finalMessage).then(() => {
        resolve();
      })
    });
  },
  /**
   *
   * @param context
   * @param reportId
   * @param update
   * @returns {Promise<ReportUpdate>}
   */
  patchReportUpdateAction(context, {reportId, update}) {
    return new Promise((resolve) =>
      reportService.patchUpdate(reportId, update)
        .then(patchedUpdate => resolve(patchedUpdate))
    );
  },

  /**
   *
   * @param context
   * @param reportId
   */
  getReportAction(context, reportId) {
    return new Promise((resolve => {
      reportService.getOne(reportId)
        .then((report) => resolve(report));
    }))
  },

  getReportsAction({commit}, params) {
    reportService.get(params).then((reports) => {
      commit('setReports', reports)
    });
  },

  /**
   *
   * @param dispatch
   * @param commit
   * @param report {Report}
   */
  deleteReportAction({commit}, report) {
    reportService.delete(report.id).then(() => {
      commit('deleteReport', report);
    })
  }
};
const mutations = {
  setCustomers(state, payload) {
    state.customer = payload;
  },
  setCategories(state, payload) {
    state.categories = payload
  },
  setReports(state, payload) {
    state.reports = payload;
  },
  /**
   *
   * @param state
   * @param report {Report}
   */
  deleteReport(state, report) {
    let i = state.reports.map(item => item.id).indexOf(report.id);
    state.reports.splice(i, 1);
  }
};
const getters = {
  getCustomer(state) {
    return state.customer;
  },
  getCategories() {
    return state.categories;
  },
  getReports(state) {
    return state.reports;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
}
